import { render, staticRenderFns } from "./ContactDistributionsByChannel.vue?vue&type=template&id=6d89c2af&scoped=true"
import script from "./ContactDistributionsByChannel.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByChannel.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByChannel.vue?vue&type=style&index=0&id=6d89c2af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d89c2af",
  null
  
)

export default component.exports